import { render } from "./customer-invoice.vue?vue&type=template&id=53938d73&scoped=true"
import script from "./customer-invoice.vue?vue&type=script&lang=js"
export * from "./customer-invoice.vue?vue&type=script&lang=js"

import "./customer-invoice.vue?vue&type=style&index=0&id=53938d73&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53938d73"]])

export default __exports__